import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IDisplayMode {
    selected_day: number,
    selected_lang: string
    selected_scenario: number,
}

const initialState = {
    selected_day: 0,
    selected_lang: 'inv',
    selected_scenario: 1,
    menu_open: false
}

export const displayMode = createSlice({
    name: 'displayMode',
    initialState,
    reducers:{
            switchSelectedDay: (state, action:PayloadAction<number>) =>{
                if(state.selected_day === action.payload)
                {
                    state.selected_day = 0
                }
                else
                {
                    state.selected_day = action.payload
                }
            },
            setLanguage: (state, action:PayloadAction<string>) =>{
                state.selected_lang = action.payload
            },
            switchMenuMode: (state, action:PayloadAction<number>) =>{
                if(state.menu_open === true){
                    state.menu_open = false
                }else{
                    state.menu_open = true
                }
            },
            setScenario: (state, action:PayloadAction<number>) => {
                state.selected_scenario = action.payload
            }
        }
    })

    export const { switchSelectedDay, setLanguage, switchMenuMode, setScenario } = displayMode.actions
    export default displayMode.reducer